/* Just Plywood — collection page enhancements:
   - open the desktop faceted-filter groups by default (mockup shows them expanded)
   - overlay a dual-thumb price range slider on the two currency inputs
   Both re-run after Tailor's AJAX filter re-renders. */
(function () {
  'use strict';

  function openDetails() {
    if (window.innerWidth < 860) return;
    document.querySelectorAll('.faceted-filters details.faceted-filter').forEach(function (d) {
      d.setAttribute('open', '');
    });
  }

  function commit(input) {
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function buildSlider(range) {
    if (range.querySelector('.jp-price-slider')) return; // already built
    var gte = range.querySelector('#Filter-Price-GTE') || range.querySelector('input[id$="GTE"]');
    var lte = range.querySelector('#Filter-Price-LTE') || range.querySelector('input[id$="LTE"]');
    if (!gte || !lte) return;
    var max = parseInt(lte.getAttribute('max') || lte.getAttribute('placeholder') || gte.getAttribute('max') || '0', 10);
    if (!max || max <= 0) return;

    var wrap = document.createElement('div');
    wrap.className = 'jp-price-slider';
    wrap.innerHTML =
      '<div class="jp-price-slider__track"><div class="jp-price-slider__fill"></div></div>' +
      '<input type="range" class="jp-price-slider__thumb jp-price-slider__thumb--min" min="0" max="' + max + '" step="1" aria-label="Minimum price">' +
      '<input type="range" class="jp-price-slider__thumb jp-price-slider__thumb--max" min="0" max="' + max + '" step="1" aria-label="Maximum price">';
    range.insertBefore(wrap, range.firstChild);

    var rmin = wrap.querySelector('.jp-price-slider__thumb--min');
    var rmax = wrap.querySelector('.jp-price-slider__thumb--max');
    var fill = wrap.querySelector('.jp-price-slider__fill');

    function curMin() { var v = parseFloat(gte.value); return isNaN(v) ? 0 : v; }
    function curMax() { var v = parseFloat(lte.value); return isNaN(v) ? max : v; }
    function paint() {
      var lo = Math.max(0, Math.min(curMin(), curMax()));
      var hi = Math.min(max, Math.max(curMin(), curMax()));
      rmin.value = lo;
      rmax.value = hi;
      fill.style.left = (lo / max * 100) + '%';
      fill.style.right = (100 - hi / max * 100) + '%';
    }
    rmin.addEventListener('input', function () {
      gte.value = Math.min(parseFloat(rmin.value), curMax());
      paint();
    });
    rmax.addEventListener('input', function () {
      lte.value = Math.max(parseFloat(rmax.value), curMin());
      paint();
    });
    rmin.addEventListener('change', function () { commit(gte); });
    rmax.addEventListener('change', function () { commit(lte); });
    gte.addEventListener('input', paint);
    lte.addEventListener('input', paint);
    paint();
  }

  function priceSliders() {
    document.querySelectorAll('.faceted-filter__price-range').forEach(buildSlider);
  }

  function enhance() {
    openDetails();
    priceSliders();
  }

  function init() {
    enhance();
    // Tailor re-renders the filter/grid on AJAX filter changes; re-apply after.
    var host = document.querySelector('.main-collection-grid');
    if (host && 'MutationObserver' in window) {
      var pending = false;
      var mo = new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () { pending = false; enhance(); });
      });
      mo.observe(host, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
